const Main = () => import ( '../views/main/main.vue')
const podIndex = () => import ('@/views/cggl/podIndex')
const podForm = () => import ('@/views/cggl/podForm')
const rmivdIndex = () => import ('@/views/cggl/rmivdIndex')
const rmivdForm = () => import ('@/views/cggl/rmivdForm')
export default [{
  path: '/cggl',
  component: Main,
  redirect: '',
  meta: {
    title: '采购管理',
    icon: 'guide'
  },
  children: [
    {
      path: 'podIndex',
      component: podIndex,
      name: 'podIndex',
      meta: { title: '采购订单', keepAlive: true }
    },
    {
      path: 'podForm',
      component: podForm,
      name: 'podForm',
      meta: { title: '采购单', keepAlive: true }
    },
    {
      path: 'rmivdIndex',
      component: rmivdIndex,
      name: 'rmivdIndex',
      meta: { title: '采购收货', keepAlive: true }
    },
    {
      path: 'rmivdForm',
      component: rmivdForm,
      name: 'rmivdForm',
      meta: { title: '采购收货单', keepAlive: true }
    }
  ]
}]
